module.exports = __webpack_public_path__ + "img/wave-back.7d6f6a69.png";